<template>
  <div class="">
    <v-tooltip bottom :disabled="!title">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" v-if="title" :class="`cellLine ${headerClass}`" :style="headerStyle">
          {{ title }}
        </span>
      </template>

      <span>
        {{ title }}
      </span>
    </v-tooltip>

  </div>
</template>

<script>
export default {
  name: 'HeaderCell',

  props: {
    title: { required: true },
    headerClass: { type: String, default: '' },
    headerStyle: { type: String, default: '' },
    isBadge: { type: Boolean, default: false },
  }
}
</script>

<style scoped>
.cellLine {
  min-height: 14px;
  max-width: 100%;
  text-wrap: wrap;
}
</style>
